import Transactions from 'components/transactions';

const TransactionsPage = () => {
  return <Transactions />;
};

export default TransactionsPage;
